// The maximum time the dealer is given to edit the order since it was created.
export const dealerOrderEditTimeLimit = 30;

// Number of remaining minutes where we show the order edit warning to the user.
export const dealerOrderEditWarningTimeLimit = 5;
